export default "__VITE_ASSET__Bkf2rxh5__";